import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FmdBadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fmd_bad"}/>
}
